import React, { Component } from "react";
import ModalImage from "react-modal-image";
import FadeIn from "react-fade-in";

const modalStyles = `
  .__react_modal_image__header {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: center !important;
    height: 40px !important;
    padding: 5px 10px !important;
    min-height: unset !important;
  }
  .__react_modal_image__icon_menu {
    display: flex !important;
    flex-direction: row !important;
    gap: 15px !important;
    margin: 0 !important;
    padding: 0 !important;
  }
`;

let id = 0;
class Portfolio extends Component {
  render() {
    if (!this.props.data) return null;

    const artwork = this.props.data.artwork.map(function (artwork) {
      let projectImage = "images/portfolio/" + artwork.image;
      let projectThumbnail = "images/portfolio/" + artwork.thumbnail;

      return (
        <div key={id++} className="columns portfolio-item">
          <style>{modalStyles}</style>

          <div
            className="item-wrap"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <ModalImage small={projectThumbnail} large={projectImage} />
            <div style={{ textAlign: "center" }}>{artwork.title}</div>
          </div>
        </div>
      );
    });

    return (
      <section id="portfolio">
        <FadeIn transitionDuration={1200}>
          <div className="row-portfolio">
            <div className="twelve columns collapsed">
              <div
                id="portfolio-wrapper"
                className="bgrid-quarters s-bgrid-thirds cf"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {artwork}
              </div>
            </div>
          </div>
        </FadeIn>
      </section>
    );
  }
}

export default Portfolio;
